// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"5c85d97d87545bb4197d","3":"1938027072c37ba839fe","4":"7643333d5bf7c5eca850","5":"4adfa098ad09805555d8"}[chunkId] + "";
};